/* eslint-disable @typescript-eslint/no-explicit-any */

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Configuration,
  ConfigurationListParams,
  Pagination,
  ConfigurationCreationParams,
  ConfigurationType,
  PresentationConfigUpdateParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class ConfigurationService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(configurationId: string): Observable<Configuration> {
    return this._httpClient.get<Configuration>(
      `${this._apiConstantsService.configurationUrl}/${configurationId}`
    );
  }

  list(
    params?: ConfigurationListParams
  ): Observable<Pagination<Configuration>> {
    return this._httpClient.get<Pagination<Configuration>>(
      this._apiConstantsService.configurationUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  update(
    configurationId: string,
    data: Partial<ConfigurationCreationParams>
  ): Observable<Configuration> {
    return this._httpClient.patch<Configuration>(
      `${this._apiConstantsService.configurationUrl}/${configurationId}`,
      data
    );
  }

  updatePresentation(
    configurationType: ConfigurationType,
    data: PresentationConfigUpdateParams
  ): Observable<Configuration> {
    return this._httpClient.patch<Configuration>(
      `${this._apiConstantsService.configurationUrl}/${configurationType}`,
      data
    );
  }

  create(data: ConfigurationCreationParams): Observable<Configuration> {
    return this._httpClient.post<Configuration>(
      this._apiConstantsService.configurationUrl,
      data
    );
  }

  delete(configurationId: string): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.configurationUrl}/${configurationId}`
    );
  }
}
